import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Util from '../../../../../../forecast-app/shared/util/util';
import {useIntl} from 'react-intl';
import {LockIcon} from 'web-components';
import {UnlockIcon} from 'web-components/icons';
import moment from 'moment';

const LockTooltip = styled.div`
	padding: 5px 0;
	.header {
		margin-bottom: 5px;
		display: flex;
		align-items: center;
		div {
			margin-left: 7px;
			flex: 1 0 auto;
		}
	}
	.title {
		font-weight: bold;
		font-size: 12px;
	}
	.left-header {
		display: flex;
	}
	.right-header {
		font-size: 12px;
		display: flex;
		flex-direction: column;
	}
	.body {
		font-size: 11px;
	}
	.month {
		font-weight: bold;
		font-style: italic;
		font-size: 11px;
	}
`;

const BudgetLockTooltip = ({lock, currencySymbol}) => {
	if (lock) {
		const intl = useIntl();
		const {fullLock, progress, startDate, actualRevenueProjectCurrency} = lock;
		const month = moment(startDate).format('MMMM YYYY');
		return (
			<LockTooltip>
				<div className={'header'}>
					<div className={'left-header'}>
						{fullLock ? <LockIcon color={'#4C4C58'} size={LockIcon.SIZE.STANDARD} /> : <UnlockIcon color={'#4C4C58'} size={'medium'} />}
						<div className={'title'}>{fullLock ? intl.formatMessage({id: 'fixed_price_lock.tooltip.month_closed'}) : intl.formatMessage({id: 'fixed_price_lock.tooltip.partially_closed'})}</div>
					</div>
					<div className={'right-header'}>
						<div>{`${intl.formatMessage({id: 'common.progress'})}: ${Util.getFormattedPercentage(progress, intl)}`}</div>
						<div>{`${intl.formatMessage({id: 'project_budget.locked_actual_revenue'})}: ${Util.getFormattedCurrencyValue(currencySymbol, actualRevenueProjectCurrency)}`}</div>
					</div>
				</div>
				<div className={'body'}>
					{fullLock ? intl.formatMessage({id: 'fixed_price_lock.tooltip.closed_message'}) : intl.formatMessage({id: 'fixed_price_lock.tooltip.partially_closed_message'})}
					<span className={'month'}>{month}</span>
				</div>
			</LockTooltip>
		);
	}
	return null;
};

BudgetLockTooltip.propTypes = {
	lock: PropTypes.object,
};

export default BudgetLockTooltip;
